import Backbone from 'backbone';
import { register } from '../../core/bootstrapper';
import * as registry from '../../../home24/core/registry';
import Fttc1Model from './fttc1Model';
import Fttc1Router from './fttc1Router';
import Fttc1View from './fttc1View';

register(null, function() {
  var fttc1Model = new Fttc1Model(registry.get('helpTreeStructureJSON'));

  if ($('#fttc-wrapper').length > 0) {
    var fttc1View = new Fttc1View({
      model: fttc1Model,
      el: $('#fttc-wrapper')
    });
    var fttc1Router = new Fttc1Router();

    fttc1Router.view = fttc1View;

    if (!Backbone.History.started) {
      Backbone.history.start();
    }
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/fttc1/fttc1Bootstrap.js
 **/